import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UiOption } from '@ui';
import { UserSearchValue } from '../../types/user-manage.types';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-search-filter',
  templateUrl: './user-search-filter.component.html',
  styleUrl: './user-search-filter.component.scss',
})
export class UserSearchFilterComponent {
  @Input() roleOptions: string[] = [];
  @Input() statusOptions: UiOption<string>[] = [];

  @Output() search = new EventEmitter<UserSearchValue>();
  @Output() reset = new EventEmitter();
  @Output() createUser = new EventEmitter();

  readonly form: FormGroup = this.fb.group({
    keyword: [''],
    role: ['all'],
    status: ['all'],
  });
  roleOpen = false;

  toggleRole() {
    this.roleOpen = !this.roleOpen;
  }

  selectRole(value: string | null) {
    this.form.controls['role'].setValue(value);
    this.roleOpen = false;
  }

  onSubmit() {
    this.search.emit(this.form.getRawValue());
  }

  onReset() {
    this.form.reset({
      keyword: '',
      role: null,
      status: null,
    });

    this.reset.emit();
  }

  onCreateUser() {
    this.createUser.emit();
  }

  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
  ) {}

  displayStr = (value: string): string => {
    if (!value) {
      return this.translate.instant('view_value.all');
    }

    return this.translate.instant(value || '');
  };
}
